import { GTMConsentStatus, UserConsent } from "./cookie-consent.model";

export const CONSENT_COOKIE_NAME = "CONSENT";

export const enum OneTrustConsentGroups {
	NecessaryCookies = "C0001",
	PerformanceCookies = "C0002",
	FunctionalCookies = "C0003",
	TargetingCookies = "C0004",
	SocialMediaCookies = "C005",
}

export const cookieConsentAccepted: UserConsent = {
	consentCookie: {
		functional: 1,
		marketing: 1,
		performance: 1,
		targeting: 1,
	},
	gdprConsent: {
		gdpr_functional_enabled: GTMConsentStatus.Accepted,
		gdpr_performance_enabled: GTMConsentStatus.Accepted,
		gdpr_targeting_enabled: GTMConsentStatus.Accepted,
		GDPRFunctionalAccepted: GTMConsentStatus.Accepted,
		GDPRPerformanceAccepted: GTMConsentStatus.Accepted,
		GDPRTargetingAccepted: GTMConsentStatus.Accepted,
	},
};

export const cookieConsentDeclined: UserConsent = {
	consentCookie: {
		functional: 0,
		marketing: 0,
		performance: 1,
		targeting: 0,
	},
	gdprConsent: {
		gdpr_functional_enabled: GTMConsentStatus.Declined,
		gdpr_performance_enabled: GTMConsentStatus.Accepted,
		gdpr_targeting_enabled: GTMConsentStatus.Declined,
		GDPRFunctionalAccepted: GTMConsentStatus.Declined,
		GDPRPerformanceAccepted: GTMConsentStatus.Declined,
		GDPRTargetingAccepted: GTMConsentStatus.Declined,
	},
};
